import {
  getAllChains,
  getListedChainIds,
  hasCapability,
} from '~/constants/chains'
import { addSentryBreadcrumb } from '~/utils/errors'

export const isListedChainId = (
  chainId: number | undefined | null,
): chainId is number => {
  if (chainId === undefined || chainId === null) return false
  return getListedChainIds().includes(chainId)
}

export const isTransactChainId = (
  chainId: number | undefined | null,
): boolean => {
  if (chainId === undefined || chainId === null) return false
  return hasCapability(chainId, 'transact')
}

export const isSwapChainId = (chainId: number | undefined | null): boolean => {
  if (chainId === undefined || chainId === null) return false
  return hasCapability(chainId, 'swap')
}

const getChainIdRank = (chainId: number): number => {
  const chains = getAllChains()
  const rank = chains.findIndex((chain) => chain.chainId === chainId)
  return rank === -1 ? chains.length + 1 : rank
}

export const sortChainIds = (chainIds: number[]): number[] => {
  return [...chainIds].sort((a, b) => getChainIdRank(a) - getChainIdRank(b))
}

export const getAllChainIds = (): number[] =>
  getAllChains().map((chain) => chain.chainId)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const customStringify = (val: any): string => {
  addSentryBreadcrumb('custom stringify')
  return JSON.stringify(val, (_, value) =>
    typeof value === 'bigint' ? value.toString() : value,
  )
}

export const getDomainFromUrl = (url: string): string => {
  const parsedUrl = new URL(url) // Throws if invalid URL
  const hostname = parsedUrl.hostname
  // Removes any potential leading 'www.'
  const simpleHostname = hostname.replace(/^www\./, '')
  return simpleHostname
}

export function areSetsEquals<T>(setA: Set<T>, setB: Set<T>): boolean {
  if (setA.size !== setB.size) {
    return false
  }

  return Array.from(setA).every((elem) => setB.has(elem))
}

declare global {
  var CAN_I_USE_JXL: boolean | undefined
}

export function isDarkMode() {
  return window.matchMedia('(prefers-color-scheme: dark)').matches
}
